import React from 'react';
import AnimatedSection from '../AnimatedSection';
import { useNavigate } from 'react-router';
import slugify from 'slugify';
import DOMPurify from 'dompurify';

const NoticeItems = ({ item }) => {
  const navigate = useNavigate();

  if (!item) return null;


  const formatTitle = (title) =>
    slugify(title, { lower: true, remove: /[*+~.()'"!:@]/g });

  const cleanContent = DOMPurify.sanitize(item.content);

  const formatDate = (dateString) => {
    if (!dateString) return "Tarih Yok"; 
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };
  return (
    <>
      <div className="notice-card-relative">
        <AnimatedSection>
          <div
            onClick={() => navigate(`/duyurular/${formatTitle(item.title)}`)}
            className="notice-card"
          >
            <div className="notice-date">{formatDate(item.createdAt)}</div>
            <div className="notice-content">
              <h3 className="notice-card-title">{item.title}</h3>
              <p
                className="notice-text"
                dangerouslySetInnerHTML={{ __html: cleanContent }}
              />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </>
  );
};

export default NoticeItems;
